/* eslint-disable max-len */
import { polyfill as promisePolyfill } from 'es6-promise';
import Cookies from 'js-cookie';
import cloneDeep from 'lodash/cloneDeep';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import App from './App';
import './components';
import router from './router';
import './vue';

promisePolyfill();

const defaultState = {
  id: null,
  token: null,
  campus: null,
  gifts: [
    {
      question: 'I like to organize people, tasks and events.',
      answer: null,
    },
    {
      question: 'I would like to start churches in places where they do not currently exist.',
      answer: null,
    },
    {
      question: 'I can readily distinguish between spiritual truth and error, good and evil.',
      answer: null,
    },
    {
      question: 'I tend to see the potential in people.',
      answer: null,
    },
    {
      question: 'I communicate the gospel to others with clarity and effectiveness.',
      answer: null,
    },
    {
      question: 'I find it natural and easy to trust God to answer my prayers.',
      answer: null,
    },
    {
      question: 'I give liberally and joyfully to people in financial need or to projects requiring support.',
      answer: null,
    },
    {
      question: 'I enjoy working behind the scenes to support the work of others.',
      answer: null,
    },
    {
      question: 'I view my home as a place to minister to people in need.',
      answer: null,
    },
    {
      question: 'I take prayer requests from others and consistently pray for them.',
      answer: null,
    },
    {
      question: 'I am approached by people who want to know my perspective on a particular passage or biblical truth.',
      answer: null,
    },
    {
      question: 'I am able to motivate others to accomplish a goal',
      answer: null,
    },
    {
      question: 'I empathize with hurting people and desire to help in their healing process.',
      answer: null,
    },
    {
      question: 'I can speak in a way that results in conviction and change in the lives of others.',
      answer: null,
    },
    {
      question: 'I enjoy spending time nurturing and caring for others.',
      answer: null,
    },
    {
      question: 'I am able to communicate God’s work effectively.',
      answer: null,
    },
    {
      question: 'I am often sought out by others for advice about spiritual or personal matters.',
      answer: null,
    },
    {
      question: 'I am careful, thorough, and skilled at managing details.',
      answer: null,
    },
    {
      question: 'I am attracted to the idea of serving in another country or ethnic community.',
      answer: null,
    },
    {
      question: 'I frequently am able to judge a person’s character based upon first impressions.',
      answer: null,
    },
    {
      question: 'I enjoy reassuring and strengthening those who are discouraged.',
      answer: null,
    },
    {
      question: 'I consistently look for opportunities to build relationships with non-Christians.',
      answer: null,
    },
    {
      question: 'I have confidence in God’s continuing provision and help, even in difficult times.',
      answer: null,
    },
    {
      question: 'I give more than a tithe so that kingdom work can be accomplished.',
      answer: null,
    },
    {
      question: 'I enjoy doing routine tasks that support the ministry.',
      answer: null,
    },
    {
      question: 'I enjoy meeting new people and helping them to feel welcomed.',
      answer: null,
    },
    {
      question: 'I enjoy praying for long periods of time and received leadings as to what God wants me to pray for.',
      answer: null,
    },
    {
      question: 'I receive information from the Spirit that I did not acquire through natural means.',
      answer: null,
    },
    {
      question: 'I am able to influence others to achieve a vision.',
      answer: null,
    },
    {
      question: 'I can patiently support those going through painful experiences as they try to stabilize their lives.',
      answer: null,
    },
    {
      question: 'I feel responsible to confront others with the truth.',
      answer: null,
    },
    {
      question: 'I have compassion for wandering believers and want to protect them.',
      answer: null,
    },
    {
      question: 'I can spend time in study knowing that presenting truth will make a difference in the lives of people.',
      answer: null,
    },
    {
      question: 'I can often find simple, practical solutions in the midst of conflict or confusion.',
      answer: null,
    },
    {
      question: 'I can clarify goals and develop strategies or plans to accomplish them.',
      answer: null,
    },
    {
      question: 'I am willing to take an active part in starting a new church.',
      answer: null,
    },
    {
      question: 'I can see through phoniness or deceit before it is evident to others.',
      answer: null,
    },
    {
      question: 'I give hope to others by directing them to the promises of God.',
      answer: null,
    },
    {
      question: 'I am effective at adapting the gospel message so that it connects with an individual’s felt need.',
      answer: null,
    },
    {
      question: 'I believe that God will help me to accomplish great things.',
      answer: null,
    },
    {
      question: 'I manage my money well in order to free more of it for giving.',
      answer: null,
    },
    {
      question: 'I willingly take on a variety of odd jobs around the church to meet the needs of others.',
      answer: null,
    },
    {
      question: 'I genuinely believe the Lord directs strangers to me who need to get connected to others.',
      answer: null,
    },
    {
      question: 'I am conscious of ministering to others as I pray.',
      answer: null,
    },
    {
      question: 'I am committed, and schedule blocks of time for reading and studying Scripture, to understand Biblical truth fully and accurately.',
      answer: null,
    },
    {
      question: 'I can adjust my leadership style to bring out the best in others.',
      answer: null,
    },
    {
      question: 'I enjoy helping people sometimes regarded as undeserving or beyond help.',
      answer: null,
    },
    {
      question: 'I boldly expose cultural trends, teachings, or events, which contradict Biblical principles.',
      answer: null,
    },
    {
      question: 'I like to provide guidance for the whole person – relationally, emotionally, spiritually, etc…',
      answer: null,
    },
    {
      question: 'I can devote considerable time to learning new Biblical truths in order to communicate them to others.',
      answer: null,
    },
    {
      question: 'I can easily select the most effective course of action from among several alternatives.',
      answer: null,
    },
    {
      question: 'I can identify and effectively use the resources needed to accomplish tasks.',
      answer: null,
    },
    {
      question: 'I can adapt well to different cultures and surroundings.',
      answer: null,
    },
    {
      question: 'I tend to see rightness or wrongness in situations.',
      answer: null,
    },
    {
      question: 'I reassure those who need to take courageous action in their faith, family, or life.',
      answer: null,
    },
    {
      question: 'I invite unbelievers to accept Christ as their Savior.',
      answer: null,
    },
    {
      question: 'I trust God in circumstances where success cannot be guaranteed by human effort alone.',
      answer: null,
    },
    {
      question: 'I am challenged to limit my lifestyle in order to give away higher percentages of my income.',
      answer: null,
    },
    {
      question: 'I see spiritual significance in doing practical tasks.',
      answer: null,
    },
    {
      question: 'I like to create a place where people do not feel that they are alone.',
      answer: null,
    },
    {
      question: 'I pray with confidence because I know that God works in response to prayer.',
      answer: null,
    },
    {
      question: 'I have insight or just know something to be true.',
      answer: null,
    },
    {
      question: 'I set goals and manage people and resources effectively to accomplish them.',
      answer: null,
    },
    {
      question: 'I have great compassion for hurting people.',
      answer: null,
    },
    {
      question: 'I see most actions as right or wrong, and feel the need to correct the wrong.',
      answer: null,
    },
    {
      question: 'I can faithfully provide long-term support and concern for others.',
      answer: null,
    },
    {
      question: 'I like to take a systemic approach to my study of the Bible.',
      answer: null,
    },
    {
      question: 'I can anticipate the likely consequences of an individual’s or group’s action.',
      answer: null,
    },
    {
      question: 'I like to help organizations or groups become more efficient.',
      answer: null,
    },
    {
      question: 'I can relate to others in culturally sensitive ways.',
      answer: null,
    },
    {
      question: 'I receive affirmation from others concerning the reliability of my insights or perceptions.',
      answer: null,
    },
    {
      question: 'I strengthen those who are wavering in their faith.',
      answer: null,
    },
    {
      question: 'I openly tell people that I am a Christian and want them to ask me about my faith.',
      answer: null,
    },
    {
      question: 'I am convinced of God’s daily presence and action in my life.',
      answer: null,
    },
    {
      question: 'I like knowing that my financial support makes a real difference in the lives and ministries of God’s people.',
      answer: null,
    },
    {
      question: 'I like to find small things that need to be done and often do them without being asked.',
      answer: null,
    },
    {
      question: 'I enjoy entertaining people and opening my home to others.',
      answer: null,
    },
    {
      question: 'When I hear about needy situations, I feel burdened to pray.',
      answer: null,
    },
    {
      question: 'I have suddenly known some things about others, but did not know how I knew them.',
      answer: null,
    },
    {
      question: 'I influence others to perform to the best of their capability.',
      answer: null,
    },
    {
      question: 'I can look beyond a person’s handicaps or problems to see a life that matters to God.',
      answer: null,
    },
    {
      question: 'I like people who are honest and will speak the truth.',
      answer: null,
    },
    {
      question: 'I enjoy giving guidance and practical support to a small group of people.',
      answer: null,
    },
    {
      question: 'I can communicate Scripture in ways that motivate others to study and want to learn more.',
      answer: null,
    },
    {
      question: 'I give practical advice to help others through complicated situations.',
      answer: null,
    },
    {
      question: 'I enjoy learning about how organizations function.',
      answer: null,
    },
    {
      question: 'I enjoy pioneering new undertakings.',
      answer: null,
    },
    {
      question: 'I can identify preaching, teaching, or communication which is not true to the Bible.',
      answer: null,
    },
    {
      question: 'I like motivating others to take steps for spiritual growth.',
      answer: null,
    },
    {
      question: 'I openly and confidently tell others what Christ has done for me.',
      answer: null,
    },
    {
      question: 'I am regularly challenging others to trust God.',
      answer: null,
    },
    {
      question: 'I give generously due to my commitment to stewardship.',
      answer: null,
    },
    {
      question: 'I feel comfortable being a helper, assisting others to do their job more effectively.',
      answer: null,
    },
    {
      question: 'I do whatever I can to make people feel that they belong.',
      answer: null,
    },
    {
      question: 'I am honored when someone asks me to pray for them.',
      answer: null,
    },
    {
      question: 'I discover important Biblical truths when reading or studying Scripture which benefit others in the Body of Christ.',
      answer: null,
    },
    {
      question: 'I am able to cast a vision that others want to be a part of.',
      answer: null,
    },
    {
      question: 'I enjoy bringing hope and joy to people living in difficult circumstances.',
      answer: null,
    },
    {
      question: 'I will speak God’s truth, even in places where it is unpopular or difficult for others to accept.',
      answer: null,
    },
    {
      question: 'I can gently restore wandering believers to faith and fellowship.',
      answer: null,
    },
    {
      question: 'I can present information and skills to others at a level that makes it easy for them to grasp and apply to their lives.',
      answer: null,
    },
    {
      question: 'I can apply Scriptural truth that others regard as practical and helpful.',
      answer: null,
    },
    {
      question: 'I can visualize a coming event, anticipate potential problems, and develop backup plans.',
      answer: null,
    },
    {
      question: 'I am able to orchestrate or oversee several church ministries.',
      answer: null,
    },
    {
      question: 'I can sense when demonic forces are at work in a person or situation.',
      answer: null,
    },
    {
      question: 'I am able to challenge or rebuke others in order to foster spiritual growth.',
      answer: null,
    },
    {
      question: 'I seek opportunities to talk about spiritual matters with unbelievers.',
      answer: null,
    },
    {
      question: 'I can move forward in spite of position or lack of support when I sense God’s blessing on an undertaking.',
      answer: null,
    },
    {
      question: 'I believe I have been given an abundance of resources so that I may give more to the Lord’s work.',
      answer: null,
    },
    {
      question: 'I readily and happily use my natural or learned skills to help wherever needed.',
      answer: null,
    },
    {
      question: 'I can make people feel at ease even in unfamiliar surroundings.',
      answer: null,
    },
    {
      question: 'I often see specific results in direct response to my prayers.',
      answer: null,
    },
    {
      question: 'I confidently share my knowledge and insights with others.',
      answer: null,
    },
    {
      question: 'I figure out where we need to go and help others to get there.',
      answer: null,
    },
    {
      question: 'I enjoy doing practical things for others who are in need.',
      answer: null,
    },
    {
      question: 'I feel compelled to expose sin wherever I see it and to challenge people to repentance.',
      answer: null,
    },
    {
      question: 'I enjoy patiently but firmly nurturing others in their development as believers.',
      answer: null,
    },
    {
      question: 'I enjoy explaining things to people so that they can grow spiritually and personally.',
      answer: null,
    },
    {
      question: 'I have insights into how to solve problems that others do not see.',
      answer: null,
    },
  ],
  passions: {
    people: [],
    issues: [],
  },
  passionsOther: {
    people: null,
    issues: null,
  },
  abilities: {},
  personality: {
    comfortable: null,
    task: null,
    excited: null,
    accomplished: null,
    meeting: null,
    concerned: null,
    value: null,

    vacation: null,
    guidelines: null,
    projects: null,
    like: null,
    routine: null,
    tasks: null,
  },
  experience: {
    spiritual: '',
    painful: '',
    educational: '',
    ministry: '',
  },
  info: {
    name: '',
    email: '',
    phone: '',
    preferred: '',
  },
};

const plugins = [];
if (Cookies.get('NGCOM')) {
  plugins.push(createPersistedState());
}

const store = new Vuex.Store({
  plugins,
  state: cloneDeep(defaultState),
  mutations: {
    setServerIdentity(state, payload) {
      state.id = payload.id;
      state.token = payload.token;
    },
    setGiftAnswer(state, payload) {
      state.gifts[payload.index].answer = payload.answer;
    },
    setPassionsByGroup(state, payload) {
      Vue.set(state.passions, payload.group, payload.passions);
    },
    setOtherPassionByGroup(state, payload) {
      Vue.set(state.passionsOther, payload.group, payload.passion);
    },
    setAbilitiesByGroup(state, payload) {
      Vue.set(state.abilities, payload.group, payload.abilities);
    },
    setPersonalityByKey(state, payload) {
      Vue.set(state.personality, payload.key, payload.value);
    },
    setExperience(state, payload) {
      Vue.set(state.experience, payload.key, payload.value);
    },
    setInfo(state, payload) {
      Vue.set(state.info, payload.key, payload.value);
    },
    setCampus(state, payload) {
      state.campus = payload;
    },
    reset() {
      store.replaceState(cloneDeep(defaultState));
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js